let playVideo = (video) => {
  video.play();
}

export default playVideo;